import { getApiClient } from '@/api-client/api-client';
import { DefaultApiSaveUserSettingsRequest, UserSettingsDto } from '@/api-client/autogenerated';

export type UserSettings = UserSettingsDto;

export const getUserSettings = async (): Promise<UserSettings> => {
  const res = await getApiClient().getUserSettings();
  return res.data;
};

export const saveUserSettings = async (
  params: DefaultApiSaveUserSettingsRequest,
): Promise<UserSettings> => {
  const res = await getApiClient().saveUserSettings(params);
  return res.data;
};

export const dismissNewUserModal = async () => {
  const res = await getApiClient().dismissNewUserModal();
  return res.data;
};
